import React, { Suspense } from 'react';
import { hot } from 'react-hot-loader';
import { BrowserRouter as Router } from 'react-router-dom';
import { useDynamicAppAndBasename } from '@/apps/root.hooks';
import { AppEntriesProps } from '@/apps/root.interface';
import { basename, appRoutePrefix } from '@/environments';
import FullLoading from '@/components/loading/full-loading';

const PayShopApp = React.lazy(() => import('@/apps/payshop'));
const TutorialApp = React.lazy(() => import('@/apps/tutorial'));

const AppEntries = ({
  basename,
  entries,
}: AppEntriesProps): JSX.Element | null => {
  const { app: App, basenameWithAppName } = useDynamicAppAndBasename({
    basename,
    entries,
  });

  return App && basenameWithAppName ? (
    <Router basename={basenameWithAppName}>
      <Suspense fallback={<FullLoading isLoading={true} />}>
        <App />
      </Suspense>
    </Router>
  ) : (
    <FullLoading isLoading={true} />
  );
};

const RootApp = () => {
  return (
    <Router>
      <AppEntries
        basename={`/${basename}`}
        entries={[
          {
            appName: appRoutePrefix.payShop,
            appComponent: PayShopApp,
          },
          {
            appName: appRoutePrefix.tutorial,
            appComponent: TutorialApp,
          },
        ]}
      />
    </Router>
  );
};

export default hot(module)(RootApp);
